import "./App.css";
import "./styles/navbar.css";
import "./styles/hero.css";
import "./styles/section.css";
import "./styles/problem-solution.css";
import "./styles/how-it-works.css";
import "./styles/impact.css";
import "./styles/portfolio.css";
import "./styles/stakeholders.css";
import "./styles/technology.css";
import "./styles/footer.css";

import Navbar from "./components/layout/Navbar";
import ScrollProgress from "./components/layout/ScrollProgress";
import Hero from "./sections/Hero";
import ProblemSolution from "./sections/ProblemSolution";
import HowItWorks from "./sections/HowItWorks";
import Impact from "./sections/Impact";
import Portfolio from "./sections/Portfolio";
import Stakeholders from "./sections/Stakeholders";
import Technology from "./sections/Technology";
import Footer from "./sections/Footer";

function App() {
  return (
    <>
      <ScrollProgress />
      <Navbar />

      <main className="site-shell">
        <Hero />
        <ProblemSolution />
        <HowItWorks />
        <Impact />
        <Portfolio />
        <Stakeholders />
        <Technology />
        <Footer />
      </main>
    </>
  );
}

export default App;
